import { useSearchParams } from 'react-router-dom';
import { InfoSection } from 'src/components/Signup/infoSection';
import { SignUpSection } from 'src/components/Signup/signUpSection/signUpSection';

import { PasswordSetting } from './PasswordSetting';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { TRANSLATION_CONSTANTS as T } from 'src/utils/translations';

export default function SignUpPage() {
  const [searchParam] = useSearchParams();
  const email = searchParam.get('email');
  const state = searchParam.get('state');
  const token = searchParam.get('token');
  const { t } = useTranslation();

  if (state && email && token) {
    return <PasswordSetting token={token} state={state} email={email} />;
  }

  return (
    <div className="tw:min-h-screen tw:flex tw:flex-col tw:lg:flex-row tw:font-['Lato'] tw:w-full tw:overflow-x-hidden">
      <Helmet title={`${t(T.empowerGPT)} - ${t(T.signup)}`} />
      <div className="tw:hidden tw:lg:flex tw:lg:min-w-0 tw:lg:shrink-0 tw:lg:w-[35%] tw:lg:overflow-y-auto">
        <InfoSection />
      </div>
      <div className="tw:flex tw:flex-1 tw:min-h-screen tw:min-w-0 tw:justify-center tw:items-center tw:lg:flex-initial tw:lg:w-[65%] tw:w-full">
        <SignUpSection />
      </div>
    </div>
  );
}
